import { Col, Row } from "reactstrap";
import { useState, useRef, useEffect, useMemo, useCallback } from "react";
import {
    CircularProgressbarWithChildren,
    buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faStop, faPause } from "@fortawesome/free-solid-svg-icons";
import CompletePopup from "./completepopup";
import RotatePhonePopup from "../RotatePhonePopup";
import Lottie from 'lottie-react';
import { useSnackbar } from "../context/SnackbarContext";
import { useLanguage } from "../context/Languagecontext";
import { useTranslatedText } from "../../hooks/useTranslatedText";

// img
import lottieAnimation1 from "../../lottie/emoji1.json"
import lottieAnimation3 from "../../lottie/emoji3.json"
import lottieAnimation4 from "../../lottie/emoji4.json"
import close from "../../img/close.png"
import tick from "../../img/tick.png"
import microphone from "../../img/microphone.png"

const Category1 = ({ hint, uploadedImage, originalData, username, category }) => {
    const { lanText, t } = useLanguage();
    const [isRecording, setIsRecording] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);
    const [recordingTime, setRecordingTime] = useState(0);
    const [audioBlob, setAudioBlob] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [audioChunks, setAudioChunks] = useState([]); // Store chunks for resume functionality
    // Audio playback states
    const [isPlaying, setIsPlaying] = useState(false);
    const [playbackTime, setPlaybackTime] = useState(0);
    const [audioDuration, setAudioDuration] = useState(0);
    const [isPaused, setIsPaused] = useState(false); // New state to track if audio is paused
    const [isRequestingMic, setIsRequestingMic] = useState(false);
    const [selectedLottie, setSelectedLottie] = useState(null);
    const [canStopRecording, setCanStopRecording] = useState(false);
    const [disable, setDisable] = useState(false);
    const lottieRef = useRef(null);
    const { showSnackbar } = useSnackbar();
    const [isCheckingConnection, setIsCheckingConnection] = useState(false);


    console.log(audioChunks, audioDuration);

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    // Detect if Safari browser specifically
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    // Combine iOS + Safari detection
    const isiOSSafari = isIOS && isSafari;
    if (!sessionStorage.getItem('micDeniedCount')) {
        sessionStorage.setItem('micDeniedCount', '0');
    }


    const [imagesPreloaded, setImagesPreloaded] = useState(false);
    const [alertModal, setAlertModal] = useState({
        show: false,
        message: '',
        title: 'Alert'
    });
    const [alertModal2, setAlertModal2] = useState({
        show: false,
        message: '',
        title: 'Alert'
    });

    const isMobile = () => {
        return window.innerWidth <= 768 || /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };

    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /Android/i.test(ua);

    const showAlert = (message, title = 'Alert') => {
        if (isMobile()) {
            // For mobile, show custom modal with browser instructions
            setAlertModal({ show: true, message, title });
        } else {
            // Use custom modal on desktop
            setAlertModal({ show: true, message, title });
        }
    };
    const showAlert2 = (message, title = 'Alert') => {
        if (isMobile()) {
            // For mobile, show custom modal with browser instructions
            setAlertModal2({ show: true, message, title });
        } else {
            // Use custom modal on desktop
            setAlertModal2({ show: true, message, title });
        }
    };




    const mediaRecorderRef = useRef(null);
    const timerRef = useRef(null);
    const streamRef = useRef(null);
    const isRecordingRef = useRef(false);
    const audioRef = useRef(null); // For audio playback
    const playbackTimerRef = useRef(null); // For playback progress
    const preloadedImagesRef = useRef(new Map()); // Cache for preloaded images

    const data = originalData.question

    const wordText = Array.isArray(data)
        ? data.find(item => item.category === category)?.answer.word ?? t.whoTalkin?.defaultWord
        : t.whoTalkin?.defaultWord;
    const translatedWord = useTranslatedText(wordText, lanText);


    const lottieAnimations = useMemo(() => [
        lottieAnimation1,
        // lottieAnimation2,
        lottieAnimation3,
        lottieAnimation4
    ], []);

    const allImages = useMemo(() => {
        return [close, tick, microphone];
    }, []);

    const playLottie = useCallback(() => {
        if (lottieRef.current) {
            lottieRef.current.play();
        }
    }, []);

    const pauseLottie = useCallback(() => {
        if (lottieRef.current) {
            lottieRef.current.pause();
        }
    }, []);


    // Preload images function
    const preloadImages = useCallback(() => {
        return Promise.all(
            allImages.map((src) => {
                return new Promise((resolve) => {
                    if (preloadedImagesRef.current.has(src)) {
                        resolve(src);
                        return;
                    }

                    const img = new Image();
                    img.onload = () => {
                        preloadedImagesRef.current.set(src, img);
                        resolve(src);
                    };
                    img.onerror = () => {
                        console.warn(`Failed to preload image: ${src}`);
                        resolve(src);
                    };
                    img.src = src;
                });
            })
        );
    }, [allImages]); // only changes when allImages changes


    // Fixed progress percentage calculation
    const getProgressPercentage = () => {
        if (isRecording) {
            // Recording progress (0-10 seconds)
            return Math.min((recordingTime / 10) * 100, 100);
        } else if ((isPlaying || isPaused)) {
            return Math.min((playbackTime / 10) * 100, 100);
        } else if (isCompleted && !isPlaying && !isPaused) {
            // Show full progress when completed and not playing/paused
            return Math.min((recordingTime / 10) * 100, 100);
        }
        return 0;
    };

    const progressPercentage = getProgressPercentage();
    const dotRotation = -135 + (270 * progressPercentage) / 100;



    const checkInternetConnection = async () => {
        // Add 2 second delay
        await new Promise(resolve => setTimeout(resolve, 1000));

        // First check navigator.onLine
        if (!navigator.onLine) {
            return false;
        }

        // Double-check with a real network request
        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

            clearTimeout(timeoutId);
            return true;
        } catch (error) {
            console.log('Network check failed:', error);
            return false;
        }
    };

    const startRecording = async () => {
        let initialPermissionState = 'prompt'; // Declare at the top of the function

        try {
            setIsRequestingMic(true);

            // Check permission state BEFORE requesting
            if (navigator.permissions) {
                try {
                    const permissionStatus = await navigator.permissions.query({ name: 'microphone' });
                    initialPermissionState = permissionStatus.state;
                } catch (permError) {
                    console.log('Permission query not supported, assuming prompt will show');
                }
            }

            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            setIsRequestingMic(false);
            setIsRecording(true);
            streamRef.current = stream;

            let options = { mimeType: "audio/webm" };
            if (!MediaRecorder.isTypeSupported("audio/webm")) {
                options = { mimeType: "audio/mp4" };
            }
            if (!MediaRecorder.isTypeSupported("audio/mp4")) {
                options = {};
            }

            const mediaRecorder = new MediaRecorder(stream, options);
            mediaRecorderRef.current = mediaRecorder;

            mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    setAudioChunks(prev => [...prev, event.data]);
                }
            };

            mediaRecorder.onstop = () => {
                setAudioChunks(current => {
                    const mimeType = mediaRecorder.mimeType || "audio/webm";
                    const blob = new Blob(current, { type: mimeType });
                    setAudioBlob(blob);
                    return current;
                });
            };

            mediaRecorder.start();

            timerRef.current = setInterval(() => {
                setRecordingTime(prev => {
                    const newTime = prev + 0.1;

                    // Enable stop button after 1 second
                    if (newTime >= 1 && !canStopRecording) {
                        setCanStopRecording(true);
                    }

                    if (newTime >= 10) {
                        stopRecording();
                        return 10;
                    }
                    return newTime;
                });
            }, 100);

        } catch (error) {
            setIsRequestingMic(false);
            setIsRecording(false);

            if (error.name === 'NotAllowedError') {
                // Check current permission state
                if (navigator.permissions) {
                    try {
                        const permissionStatus = await navigator.permissions.query({ name: 'microphone' });

                        if (permissionStatus.state === 'denied' && initialPermissionState === 'denied') {
                            // Permission was ALREADY blocked - popup never showed
                            if (isAndroid || /Android/i.test(navigator.userAgent)) {
                                showAlert(t.whoTalkin?.blockedIOS || "Microphone permission is blocked. To enable:\n1. Tap the three dots (⋮) in browser\n2. Go to Site settings\n3. Tap Microphone\n4. Select 'Allow'");
                            } else {
                                showAlert(t.whoTalkin?.blockedIOS || "Microphone permission is blocked. Please enable it in your browser settings.");
                            }
                        } else {
                            // User just clicked "Block" or "Deny" on the popup that was shown
                            if (isiOSSafari) {
                                // Get micDeniedCount from sessionStorage or default to 0
                                let micDeniedCount = parseInt(sessionStorage.getItem('micDeniedCount'), 10) || 0;

                                if (micDeniedCount > 2) {
                                    // Safari has stopped showing system alert - show custom modal
                                    showAlert2(t.whoTalkin?.blockedIOS || "Microphone permission is blocked. Please enable it in your browser settings.");
                                    // setDisable(true);
                                } else {
                                    // Safari still showing system alert - show snackbar and auto-refresh after 1 second
                                    showSnackbar(t.whoTalkin?.denied || "Microphone access was denied. Please refresh the page.", "error");
                                    micDeniedCount += 1;
                                    sessionStorage.setItem('micDeniedCount', micDeniedCount.toString());
                                    setDisable(true);
                                    // Auto-refresh after 1 second
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 1000);
                                }
                            } else {
                                // Non-iOS Safari behavior
                                showSnackbar(t.whoTalkin?.denied || "Microphone access was denied", "error");
                                setDisable(true);

                                // Auto-hide after 3 seconds
                                setTimeout(() => {
                                    window.location.reload();
                                }, 1000);
                            }

                        }
                    } catch (permError) {
                        // Fallback if permissions API fails
                        if (isiOSSafari) {
                            // Get micDeniedCount from sessionStorage or default to 0
                            let micDeniedCount = parseInt(sessionStorage.getItem('micDeniedCount'), 10) || 0;

                            if (micDeniedCount > 2) {
                                // Safari has stopped showing system alert - show custom modal
                                showAlert2(t.whoTalkin?.blockedIOS || "Microphone permission is blocked. Please enable it in your browser settings.");
                                // setDisable(true);
                            } else {
                                // Safari still showing system alert - show snackbar and auto-refresh after 1 second
                                showSnackbar(t.whoTalkin?.denied || "Microphone access was denied. Please refresh the page.", "error");
                                micDeniedCount += 1;
                                sessionStorage.setItem('micDeniedCount', micDeniedCount.toString());
                                setDisable(true);
                                // Auto-refresh after 1 second
                                setTimeout(() => {
                                    window.location.reload();
                                }, 1000);
                            }
                        } else {
                            // Non-iOS Safari behavior
                            showSnackbar(t.denied || "Microphone access was denied", "error");
                            setDisable(true);
                            // Auto-hide after 3 seconds
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        }
                    }
                } else {
                    // Browser doesn't support permissions API
                    if (isiOSSafari) {
                        // Get micDeniedCount from sessionStorage or default to 0
                        let micDeniedCount = parseInt(sessionStorage.getItem('micDeniedCount'), 10) || 0;

                        if (micDeniedCount > 2) {
                            // Safari has stopped showing system alert - show custom modal
                            showAlert2(t.whoTalkin?.blockedIOS || "Microphone permission is blocked. Please enable it in your browser settings.");
                            // setDisable(true);
                        } else {
                            // Safari still showing system alert - show snackbar and auto-refresh after 1 second
                            showSnackbar(t.whoTalkin?.denied || "Microphone access was denied. Please refresh the page.", "error");
                            micDeniedCount += 1;
                            sessionStorage.setItem('micDeniedCount', micDeniedCount.toString());
                            setDisable(true);
                            // Auto-refresh after 1 second
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        }
                    } else {
                        // Non-iOS Safari behavior
                        showSnackbar(t.whoTalkin?.denied || "Microphone access was denied", "error");
                        setDisable(true);

                        // Auto-hide after 3 seconds
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    }
                }
            }
        }
    };

    // Stop/pause recording
    const stopRecording = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }

        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
            mediaRecorderRef.current.stop();
        }

        if (streamRef.current) {
            streamRef.current.getTracks().forEach(track => track.stop());
            streamRef.current = null;
        }

        setIsRecording(false);
        setIsCompleted(true);
        setCanStopRecording(false); // Reset the flag
    };

    // Also update your restartRecording function to properly clean up audio:
    const restartRecording = () => {
        setIsCompleted(false);
        setRecordingTime(0);
        setAudioBlob(null);
        setAudioChunks([]);
        setIsPlaying(false);
        setIsPaused(false);
        setPlaybackTime(0);
        setAudioDuration(0);
        setCanStopRecording(false);

        // Clean up existing audio properly
        if (audioRef.current) {
            audioRef.current.pause();
            if (audioRef.current.src) {
                URL.revokeObjectURL(audioRef.current.src);
            }
            audioRef.current = null;
        }

        // Clear playback timer
        if (playbackTimerRef.current) {
            clearInterval(playbackTimerRef.current);
            playbackTimerRef.current = null;
        }
    };

    // Fixed audio playback functions
    const playAudio = () => {
        if (!audioBlob) return;

        // Only create new audio if it doesn't exist
        if (!audioRef.current) {
            try {
                const audioUrl = URL.createObjectURL(audioBlob);
                const audio = new Audio();

                // Set up audio element properly for Safari
                audio.preload = 'metadata';
                audio.controls = false;

                // Important for Safari: Set source after setting up event listeners
                audio.addEventListener('loadstart', () => {
                    console.log('Audio load started');
                });

                audio.addEventListener('loadedmetadata', () => {
                    console.log('Audio metadata loaded, duration:', audio.duration);
                    setAudioDuration(audio.duration);
                });

                audio.addEventListener('canplay', () => {
                    console.log('Audio can play');
                    // Now we can safely play
                    playNow();
                });

                audio.addEventListener('error', (e) => {
                    console.error('Audio error:', e);
                    setIsPlaying(false);
                    setIsPaused(false);
                    // showAlert(t.playingError);
                    showSnackbar(t.playingError, "error");
                });

                audio.addEventListener('ended', () => {
                    setIsPlaying(false);
                    setIsPaused(false);
                    setPlaybackTime(0);
                    if (playbackTimerRef.current) {
                        clearInterval(playbackTimerRef.current);
                        playbackTimerRef.current = null;
                    }
                });

                audioRef.current = audio;
                audio.src = audioUrl;

                // For Safari, we need to load the audio explicitly
                audio.load();

            } catch (error) {
                console.error('Error creating audio:', error);
                setIsPlaying(false);
                setIsPaused(false);
                // showAlert(t.playingError);
                showSnackbar(t.playingError, "error");
            }
        } else {
            // Audio already exists, just play it
            playNow();
        }
    };

    const resumeAudio = () => {
        if (audioRef.current) {
            // Set the current time to where it was paused
            audioRef.current.currentTime = playbackTime;
            playNow();
        }
    };
    const playNow = () => {
        if (!audioRef.current) return;

        const playPromise = audioRef.current.play();

        if (playPromise !== undefined) {
            playPromise.then(() => {
                setIsPlaying(true);
                setIsPaused(false);

                if (playbackTimerRef.current) {
                    clearInterval(playbackTimerRef.current);
                }

                playbackTimerRef.current = setInterval(() => {
                    if (audioRef.current && !audioRef.current.paused && !audioRef.current.ended) {
                        setPlaybackTime(audioRef.current.currentTime);
                    }
                }, 50);

            }).catch(error => {
                console.error('Error playing audio:', error);
                setIsPlaying(false);
                setIsPaused(false);

                // Safari might require user interaction
                if (error.name === 'NotAllowedError') {
                    // showAlert(t.startError);
                    showSnackbar(t.startError, "error");
                }
            });
        }
    };

    const pauseAudio = () => {
        if (audioRef.current && !audioRef.current.paused) {
            audioRef.current.pause();
            setIsPlaying(false);
            setIsPaused(true);
            if (playbackTimerRef.current) {
                clearInterval(playbackTimerRef.current);
                playbackTimerRef.current = null;
            }
        }
    };

    const handleVisibilityChange = useCallback(() => {
        if (document.hidden) {
            // Stop recording if active
            if (isRecordingRef.current) {
                if (timerRef.current) {
                    clearInterval(timerRef.current);
                    timerRef.current = null;
                }
                if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
                    mediaRecorderRef.current.stop();
                }
                if (streamRef.current) {
                    streamRef.current.getTracks().forEach(track => track.stop());
                    streamRef.current = null;
                }
                setIsRecording(false);
                setIsCompleted(true);
                setCanStopRecording(false);
            }

            // Pause audio if playing
            if (audioRef.current && !audioRef.current.paused) {
                audioRef.current.pause();
                setIsPlaying(false);
                setIsPaused(true);
                if (playbackTimerRef.current) {
                    clearInterval(playbackTimerRef.current);
                    playbackTimerRef.current = null;
                }
            }
        }
    }, []);

    // 5. Enhanced cleanup function
    const cleanup = () => {
        // Clear timers
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
        if (playbackTimerRef.current) {
            clearInterval(playbackTimerRef.current);
            playbackTimerRef.current = null;
        }

        // Stop media stream
        if (streamRef.current) {
            streamRef.current.getTracks().forEach(track => track.stop());
            streamRef.current = null;
        }

        // Stop media recorder
        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
            mediaRecorderRef.current.stop();
            mediaRecorderRef.current = null;
        }

        // Clean up audio
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            if (audioRef.current.src) {
                URL.revokeObjectURL(audioRef.current.src);
            }
            audioRef.current = null;
        }
    };

    const base64ToFile = (base64String, fileName) => {
        const arr = base64String.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], fileName, { type: mime });
    };


    // 6. Updated uploadAudio function with proper file extension
    const uploadAudio = async () => {
        if (!audioBlob) {
            return;
        }

        // Check if recording is less than 1 second
        if (recordingTime < 1) {
            showAlert(t.recordError);
            return;
        }

        setIsUploading(true);
        const deviceIp = localStorage.getItem("deviceIp");
        try {
            const formData = new FormData();

            let fileName = 'recording.webm';
            if (audioBlob.type.includes('mp4')) {
                fileName = 'recording.mp4';
            } else if (audioBlob.type.includes('wav')) {
                fileName = 'recording.wav';
            }

            const audioFile = new File([audioBlob], fileName, { type: audioBlob.type });
            formData.append('contentFile', audioFile);
            formData.append('hint', hint);
            if (uploadedImage) {
                if (uploadedImage.startsWith('data:image')) {
                    formData.append('uploadedImage', base64ToFile(uploadedImage, 'hintImage.jpg'));
                } else {
                    formData.append('uploadedImage', uploadedImage);
                }
            }
            formData.append('category', category);
            formData.append("webCategory", category);
            formData.append('word', wordText);
            formData.append('userLocation', "allow");
            formData.append('id', originalData.id);
            formData.append('deviceIp', deviceIp);

            await axios.post('https://api.lolcards.link/api/newinbox/create', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            // Clean up audio URL
            if (audioRef.current?.src) {
                URL.revokeObjectURL(audioRef.current.src);
            }

            // Complete state cleanup
            cleanup();

            // Reset all states
            setIsCompleted(false);
            setIsRecording(false);
            setRecordingTime(0);
            setAudioBlob(null);
            setAudioChunks([]);
            setIsPlaying(false);
            setIsPaused(false);
            setPlaybackTime(0);
            setAudioDuration(0);

            setShowSuccessModal(true);
            const url = new URL(window.location.href);
            url.searchParams.set('success', '1'); // add ?success=1
            window.history.pushState({ success: true }, '', url.toString());
            // setTimeout(() => {
            //     const isAndroid = /Android/i.test(navigator.userAgent);
            //     const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

            //     let playStoreURL = 'https://api.lolcards.link/api/download?source=a7b8b02061';
            //     let appStoreURL = 'https://api.lolcards.link/api/download?source=a7b8b02061';

            //     const timer = sessionStorage.getItem("timer");
            //     if (timer === "true" && navigator.onLine) {
            //         if (isAndroid) {
            //             window.location.href = playStoreURL;
            //             // navigate(`/${username}/${category}`);
            //         } else if (isiOS) {
            //             window.location.href = appStoreURL;
            //             // navigate(`/${username}/${category}`);
            //         } else {
            //             window.location.href = playStoreURL;
            //             // navigate(`/${username}/${category}`);
            //         }
            //     }
            // }, timeoutDuration);

        } catch (error) {
            console.error('Error uploading audio:', error);
            showSnackbar(t?.common?.apiFail || 'Request failed. Please try again after some time!', "error");

        } finally {
            setIsUploading(false);
        }
    };


    // 7. Add this check for Safari compatibility
    const checkSafariCompatibility = () => {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            console.log('Safari detected - using enhanced audio compatibility mode');
        }
        return isSafari;
    };

    useEffect(() => {
        const isDisabled = isUploading || isRecording || isCheckingConnection || isPlaying;
        window.dispatchEvent(new CustomEvent('dropdownDisabledState', {
            detail: { disabled: isDisabled }
        }));
    }, [isUploading, isRecording, isCheckingConnection, isPlaying]);

    useEffect(() => {
        isRecordingRef.current = isRecording;
    }, [isRecording]);

    // 8. Add this to your useEffect for initialization
    useEffect(() => {
        const initializeComponent = async () => {
            checkSafariCompatibility();

            // Select random Lottie animation
            const randomIndex = Math.floor(Math.random() * lottieAnimations.length);
            setSelectedLottie(lottieAnimations[randomIndex]);

            // Preload images (now only buttons)
            try {
                await preloadImages();
                setImagesPreloaded(true);
            } catch (error) {
                console.error('Error preloading images:', error);
                setImagesPreloaded(true);
            }
        };

        initializeComponent();
    }, [lottieAnimations, preloadImages]);

    useEffect(() => {
        if (isRecording || isPlaying) {
            playLottie();
        } else {
            pauseLottie();
        }
    }, [isRecording, isPlaying, playLottie, pauseLottie]);

    // Update your handlePlayPauseClick function:
    const handlePlayPauseClick = () => {
        if (isPlaying) {
            pauseAudio();
        } else if (isPaused) {
            // Resume from paused position
            resumeAudio();
        } else {
            // Start playing from beginning
            playAudio();
        }
    };

    const handleMainButtonClick = async () => {
        if (!isRecording && !isCompleted) {
            await startRecording();
        } else if (isRecording) {
            stopRecording();
        }
    };

    // Handle close button click (restart)
    const handleCloseButtonClick = () => {
        if (isRecording) {
            cleanup();
            setIsRecording(false);
            setRecordingTime(0);
            setAudioChunks([]);
        } else {
            restartRecording();
        }
    };

    // Handle tick button click (upload)
    const handleTickButtonClick = async () => {
        try {
            // Set checking state to show loader
            setIsCheckingConnection(true);

            // Check internet connection first (includes 2 second delay)
            const isOnline = await checkInternetConnection();

            setIsCheckingConnection(false);

            if (!isOnline) {
                showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
                return;
            }

            if (audioRef.current && !audioRef.current.paused) {
                audioRef.current.pause();
                setIsPlaying(false);
                setIsPaused(true);
                if (playbackTimerRef.current) {
                    clearInterval(playbackTimerRef.current);
                    playbackTimerRef.current = null;
                }
            }

            await uploadAudio();
            await axios.patch('https://api.lolcards.link/api/admin/monitoring', { categoryname: category, id: originalData.id });
            // console.log('Monitoring updated:', response.data);
        } catch (err) {
            console.error('Error in handleTickButtonClick:', err);
        }
    };

    useEffect(() => {
        const handlePopState = () => {
            if (showSuccessModal) {
                setShowSuccessModal(false);
                // sessionStorage.setItem("timer", "false");
                const url = new URL(window.location.href);
                if (url.searchParams.has("success")) {
                    url.searchParams.delete("success");
                    window.history.replaceState({}, "", url.pathname);
                }
            }
        };

        // Add state to history when modal opens
        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [showSuccessModal]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get("success") === "1") {
            setShowSuccessModal(true);
        }

    }, [showSuccessModal]);

    // Cleanup on unmount
    useEffect(() => {
        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("pagehide", handleVisibilityChange); // Safari minimize fix

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("pagehide", handleVisibilityChange);
            cleanup();
        };
    }, [handleVisibilityChange]);

    // Debug logging
    // useEffect(() => {
    //     console.log('Progress states:', {
    //         isRecording,
    //         isPlaying,
    //         isPaused,
    //         isCompleted,
    //         recordingTime,
    //         playbackTime,
    //         audioDuration,
    //         progressPercentage
    //     });
    // }, [isRecording, isPlaying, isPaused, isCompleted, recordingTime, playbackTime, audioDuration, progressPercentage]);

    const isSmallScreen = window.innerWidth <= 380;
    const isInAppBrowser = () => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        return /Instagram|FBAN|FBAV|Messenger|Telegram|Snapchat|Snap/i.test(ua);
    };

    return (
        <div className='GTRegular' style={{ background: "#684BB9" , height : "100dvh" }}>
            <div className='hint-bg pt-42 h-100'>
                <Row className='m-0 h-100'>
                    <Col className="p-0 d-flex flex-column justify-content-between" style={{ height: '100%' }}>

                        {/* STEP 1 - Top Section (33.33%) */}
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                                height: '14%',
                                padding: '20px 0'
                            }}
                        >
                            <div className="text-center" style={{ maxWidth: "90vw" }}>
                                <p
                                    className="text-white mx-auto ps-2 m-0 pt-3"
                                    style={{
                                        fontSize: "clamp(16px, 4.5vw, 25px)" , lineHeight: "1.2"
                                    }}
                                >
                                    {t?.whoTalkin?.speakWords1} <br /> {t?.whoTalkin?.speakWords2}
                                </p>
                            </div>

                        </div>

                        {/* STEP 2 - Middle Section (33.33%) */}
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                                height: '53.33%'
                            }}
                        >
                            <div className="d-flex justify-content-center align-items-center">
                                {/* Circular Progress Bar Container */}
                                <div
                                    className="position-relative "
                                    style={{
                                        width: 285,
                                        height: 285,
                                    }}
                                >
                                    {/* Circular Progress Bar */}
                                    <CircularProgressbarWithChildren
                                        value={progressPercentage}
                                        circleRatio={0.75}
                                        styles={buildStyles({
                                            rotation: 0.625,
                                            strokeLinecap: "round",
                                            pathColor: "#fff",
                                            trailColor: "rgba(255, 255, 255, 0.66)",
                                            pathTransition: (isRecording || isPlaying) ? "stroke-dashoffset 0.05s linear" : "stroke-dashoffset 0.3s ease",
                                        })}
                                        strokeWidth={3}
                                    >
                                        {/* Inner colored circle with Lottie */}
                                        <div
                                            className="rounded-circle d-flex justify-content-center align-items-center"
                                            style={{
                                                width: "253px",
                                                height: "253px",
                                                backgroundColor: "#D5C8F8"
                                            }}
                                        >
                                            {selectedLottie && (
                                                <div
                                                    style={{
                                                        width: "180px",
                                                        height: "180px",
                                                        opacity: imagesPreloaded ? 1 : 0.7,
                                                        transition: "opacity 0.3s ease"
                                                    }}
                                                >
                                                    <Lottie
                                                        lottieRef={lottieRef}
                                                        animationData={selectedLottie}
                                                        loop={true}
                                                        autoplay={false}
                                                        style={{
                                                            width: "100%",
                                                            height: "100%"
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            {/* Loading indicator */}
                                            {!imagesPreloaded && (
                                                <div
                                                    className="position-absolute d-flex justify-content-center align-items-center"
                                                    style={{
                                                        width: "200px",
                                                        height: "200px",
                                                        backgroundColor: "#D5C8F8",
                                                        borderRadius: "50%"
                                                    }}
                                                >
                                                    <div
                                                        className="spinner-border text-white"
                                                        style={{ width: "2rem", height: "2rem" }}
                                                        role="status"
                                                    >
                                                        <span className="visually-hidden">{t.loading}</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </CircularProgressbarWithChildren>

                                    {/* Fixed Moving Dot/Pointer */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            width: "12px",
                                            height: "12px",
                                            backgroundColor: "#fff",
                                            borderRadius: "50%",
                                            transform: `translate(-50%, -50%) rotate(${dotRotation}deg) translateY(-138px)`,
                                            transformOrigin: "center",
                                            boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                                            transition: (isRecording || isPlaying) ? "transform 0.05s linear" : "transform 0.3s ease",
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* STEP 3 - Bottom Section (33.33%) */}
                        <div
                            className="d-flex justify-content-center align-items-center px-3 mb-3"
                            style={{
                                height: '33.33%'
                            }}
                        >
                            <div
                                className='bg-white rounded-5 position-relative mt-1 border'
                                style={{
                                    minHeight: isSmallScreen ? "145px" : "185px",
                                    width: "100%",
                                    maxWidth: "500px",
                                    boxShadow: '0px 4px 3.1px rgba(0,0,0,0.1)'
                                }}
                            >
                                <div
                                    className='GTBold d-flex h-50 align-items-center justify-content-center px-4 text-center'
                                    style={{
                                        minHeight: isSmallScreen ? "70px" : "90px",
                                        fontSize: "20px",
                                        paddingTop: "10px"
                                    }}
                                >
                                    {translatedWord}
                                </div>
                                <hr className="m-0" style={{ borderTop: "2px solid #684BB9" }} />
                                <div
                                    className='px-3 fw-semibold text-start d-flex flex-column align-items-center justify-content-center'
                                    style={{ minHeight: isSmallScreen ? "75px" : "95px", height: "55%" }}
                                >
                                    {/* Three Button Layout */}
                                    <div className="d-flex align-items-center justify-content-evenly gap-4 w-100">
                                        {/* Left Button Slot (Close) */}
                                        <div style={{ width: isSmallScreen ? "45px" : "55px", height: isSmallScreen ? "45px" : "55px" }}>
                                            {(isCompleted) ? (
                                                <button
                                                    className="btn rounded-circle d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: isSmallScreen ? "45px" : "55px",
                                                        height: isSmallScreen ? "45px" : "55px",
                                                        backgroundColor: "#F0F0F0",
                                                        border: "none",
                                                        transition: "all 0.3s ease"
                                                    }}
                                                    onClick={handleCloseButtonClick}
                                                    disabled={isUploading || isCheckingConnection}
                                                >
                                                    <img src={close} alt="close" width={25} height={25} className="img-fluid" />
                                                </button>
                                            ) : (
                                                <div style={{ width: isSmallScreen ? "45px" : "55px", height: isSmallScreen ? "45px" : "55px" }}></div>
                                            )}
                                        </div>

                                        {isCompleted ? (
                                            <div
                                                className="rounded-circle d-flex align-items-center justify-content-center"
                                                style={{
                                                    width: isSmallScreen ? "55px" : "65px",
                                                    height: isSmallScreen ? "55px" : "65px",
                                                    backgroundColor: "white",
                                                    border: "none",
                                                    boxShadow: "0 0px 5.15px 0px rgba(0,0,0,0.2)",
                                                    transform: isPlaying ? "scale(1.05)" : "scale(1)",
                                                    animation: isPlaying ? "pulse 1.5s infinite" : "none"
                                                }}
                                            >
                                                <button
                                                    className="btn rounded-circle d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: isSmallScreen ? "45px" : "55px",
                                                        height: isSmallScreen ? "45px" : "55px",
                                                        backgroundColor: "#684BB9",
                                                        border: "none",
                                                        color: "white",
                                                    }}
                                                    onClick={handlePlayPauseClick}
                                                    disabled={isUploading || isCheckingConnection}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={isPlaying ? faPause : faPlay}
                                                        style={{ fontSize: isSmallScreen ? "20px" : "25px" }}
                                                    />
                                                </button>
                                            </div>
                                        ) : (
                                            <div
                                                className="rounded-circle d-flex align-items-center justify-content-center"
                                                style={{
                                                    width: isSmallScreen ? "55px" : "65px",
                                                    height: isSmallScreen ? "55px" : "65px",
                                                    backgroundColor: "white",
                                                    border: "none",
                                                    transition: "all 0.3s ease",
                                                    boxShadow: "0 0px 5.15px 0px rgba(0,0,0,0.2)",
                                                    transform: isRecording ? "scale(1.05)" : "scale(1)",
                                                    animation: isRecording ? "pulse 1.5s infinite" : "none"
                                                }}
                                            >
                                                <button
                                                    className="btn rounded-circle d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: isSmallScreen ? "45px" : "55px",
                                                        height: isSmallScreen ? "45px" : "55px",
                                                        backgroundColor: "#684BB9",
                                                        border: "none",
                                                        color: "white",
                                                        opacity: (isRecording && !canStopRecording) || disable ? 1 : 1, // Visual feedback
                                                        cursor: (isRecording && !canStopRecording) || disable ? 'not-allowed' : 'pointer'
                                                    }}
                                                    onClick={handleMainButtonClick}
                                                    disabled={isUploading || isRequestingMic || (isRecording && !canStopRecording) || disable}
                                                >
                                                    {isRequestingMic ? (
                                                        <div
                                                            className="spinner-border spinner-border-sm"
                                                            style={{
                                                                width: "20px",
                                                                height: "20px",
                                                                color: "white"
                                                            }}
                                                        />
                                                    ) : isRecording ? (
                                                        <FontAwesomeIcon icon={faStop} style={{ fontSize: "25PX" }} />
                                                    ) : (
                                                        <img src={microphone} alt="microphone" className="img-fluid" />
                                                    )}
                                                </button>
                                            </div>
                                        )}

                                        {/* Right Button Slot (Tick) */}
                                        <div style={{ width: isSmallScreen ? "45px" : "55px", height: isSmallScreen ? "45px" : "55px" }}>
                                            {isCompleted ? (
                                                <button
                                                    className="btn rounded-circle d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: isSmallScreen ? "45px" : "55px",
                                                        height: isSmallScreen ? "45px" : "55px",
                                                        backgroundColor: "#F0F0F0",
                                                        border: "none",
                                                        transition: "all 0.3s ease",
                                                    }}
                                                    onClick={handleTickButtonClick}
                                                    disabled={isUploading || isCheckingConnection}
                                                >
                                                    {isUploading || isCheckingConnection ? (
                                                        <div
                                                            className="spinner-border spinner-border-sm"
                                                            style={{
                                                                width: "20px",
                                                                height: "20px",
                                                                color: "#684BB9"
                                                            }}
                                                        />
                                                    ) : (
                                                        <img src={tick} alt="tick" width={25} height={25} className="img-fluid" />
                                                    )}
                                                </button>
                                            ) : (
                                                <div style={{ width: isSmallScreen ? "45px" : "55px", height: isSmallScreen ? "45px" : "55px" }}></div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Col>
                </Row>
            </div>

            {alertModal.show && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{
                        zIndex: 9999,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        backdropFilter: 'blur(8px)'
                    }}
                    onClick={() => setAlertModal({ show: false })}
                >
                    <div
                        className="popup-bg rounded-4 p-3 m-3"
                        style={{
                            maxWidth: '420px',
                            width: '90%',
                            boxShadow: '0 20px 55px rgba(0, 0, 0, 0.3)',
                            maxHeight: '90vh',
                            overflowY: 'auto'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Content */}
                        <div
                            className="text-center rounded-4 p-2 mx-auto"
                            style={{
                                maxWidth: "360px",
                                // border: "1px solid #e9ecef"
                            }}
                        >
                            {/* Icon */}
                            <div
                                className="d-flex align-items-center justify-content-center mx-auto mb-2"
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "50%",
                                    background: "#D5C8F8",
                                    fontSize: "22px"
                                }}
                            >
                                🎤
                            </div>

                            {/* Title */}
                            <p className="mb-2 fw-semibold popup-main-color" style={{ fontSize: "18px" }}>
                                {t?.whoTalkin?.micPermissionTitle}
                            </p>

                            {/* Description */}
                            <p className="mb-3" style={{ fontSize: "13px", lineHeight: "1.3", color: "#A7A7A7" }}>
                                {t?.whoTalkin?.micPermissionDesc}
                            </p>

                            {/* Steps */}
                            <div
                                className="text-start popup-center-bg d-flex flex-column justify-content-around align-items-center popup-border-dashed"
                                style={{
                                    fontSize: "16px",
                                    lineHeight: "1.7",
                                    borderRadius: "12px",
                                    padding: "12px 12px 13px 12px",
                                }}
                            >
                                <h6 className="GTBold text-center popup-main-color">{t?.whoTalkin?.steps} </h6>
                                <ol className="m-0 my-4 popup-main-color">
                                    <li className="mb-2" >{t?.whoTalkin?.step1.text} <b>{t?.whoTalkin?.step1.bold}</b> {t?.whoTalkin?.step1.text2}</li>
                                    <li className="mb-2" >{t?.whoTalkin?.step2.text} <b>{t?.whoTalkin?.step2.bold}</b> {t?.whoTalkin?.step2.text2}</li>
                                    <li className="mb-2" >{t?.whoTalkin?.step3.text} <b>{t?.whoTalkin?.step3.bold}</b> {t?.whoTalkin?.step3.text2}</li>
                                    <li className="" >{t?.whoTalkin?.step4.text} <b>{t?.whoTalkin?.step4.bold}</b> {t?.whoTalkin?.step4.text2}</li>
                                </ol>
                            </div>
                        </div>

                        {/* Button */}
                        <div className="text-center mt-3">
                            <button
                                className="btn fw-semibold"
                                style={{
                                    width: "90%",
                                    backgroundColor: '#684BB9',
                                    color: 'white',
                                    borderRadius: '10px',
                                    fontSize: '16px',
                                    padding: '10.px'
                                }}
                                onClick={() => setAlertModal({ show: false })}
                            >
                                {t?.whoTalkin?.close}
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {alertModal2.show && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{
                        zIndex: 9999,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        backdropFilter: 'blur(8px)'
                    }}
                    onClick={() => setAlertModal2({ show: false })}
                >
                    <div
                        className="popup-bg rounded-4 p-3 m-3"
                        style={{
                            maxWidth: '420px',
                            width: '90%',
                            boxShadow: '0 20px 55px rgba(0, 0, 0, 0.3)',
                            maxHeight: '90vh',
                            overflowY: 'auto'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Content */}
                        <div
                            className="text-center rounded-4 p-2 mx-auto"
                            style={{
                                maxWidth: "360px",
                                // border: "1px solid #e9ecef"
                            }}
                        >
                            {/* Icon */}
                            <div
                                className="d-flex align-items-center justify-content-center mx-auto mb-2"
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "50%",
                                    background: "#D5C8F8",
                                    fontSize: "22px"
                                }}
                            >
                                🎤
                            </div>

                            {/* Title */}
                            <p className="mb-2 fw-semibold popup-main-color" style={{ fontSize: "18px" }}>
                                {t?.whoTalkin?.micPermissionTitle}
                            </p>

                            {/* Description */}
                            <p className="mb-3" style={{ fontSize: "13px", lineHeight: "1.3", color: "#A7A7A7" }}>
                                {t?.whoTalkin?.micPermissionDesc}
                            </p>

                            {/* Steps */}
                            <div
                                className="text-start popup-center-bg d-flex flex-column justify-content-around align-items-center popup-border-dashed"
                                style={{
                                    fontSize: "16px",
                                    lineHeight: "1.7",
                                    borderRadius: "12px",
                                    padding: "12px 12px 13px 12px",
                                }}
                            >
                                <h6 className="GTBold text-center popup-main-color">{t?.whoTalkin?.steps} </h6>
                                <ol className="m-0 my-4 popup-main-color">
                                    <li className="mb-2 popup-main-color ios-item">
                                        <span className="pe-2">{t?.whoTalkin?.ios1.text}</span>
                                        (<b className="icon ios-icon-1"></b>)
                                        <b className="px-2">{t?.whoTalkin?.ios1.bold}</b>
                                        ( <b className="icon ios-icon-2 mx-1"></b> )
                                        <span className="ps-2">{t?.whoTalkin?.ios1.text2}</span>
                                    </li>
                                    <li className="mb-2 popup-main-color">{t?.whoTalkin?.ios2.text} <b>{t?.whoTalkin?.ios2.bold}</b> {t?.whoTalkin?.ios2.text2}</li>
                                    <li className="mb-2 popup-main-color">{t?.whoTalkin?.ios3.text} <b>{t?.whoTalkin?.ios3.bold}</b> {t?.whoTalkin?.ios3.text2}</li>
                                    <li className="popup-main-color">{t?.whoTalkin?.ios4.text} <b>{t?.whoTalkin?.ios4.bold}</b> {t?.whoTalkin?.ios4.text2}</li>
                                </ol>
                            </div>
                        </div>

                        {/* Button */}
                        <div className="text-center mt-3">
                            <button
                                className="btn fw-semibold"
                                style={{
                                    width: "90%",
                                    backgroundColor: '#684BB9',
                                    color: 'white',
                                    borderRadius: '10px',
                                    fontSize: '16px',
                                    padding: '10.px'
                                }}
                                onClick={() => setAlertModal2({ show: false })}
                            >
                                {t?.whoTalkin?.close}
                            </button>
                        </div>
                    </div>
                </div>
            )}


            <RotatePhonePopup
                excludeWhen={[]}
            />

            {/* Success Modal */}
            <CompletePopup
                showSuccessModal={showSuccessModal}
                toggle={() => setShowSuccessModal(false)}
                data={originalData}
                username={username}
                category={category}
            />

            {/* CSS for animations */}
            <style jsx>{`
                @keyframes pulse {
                    0% {
                        transform: scale(1.1);
                    }
                    70% {
                        transform: scale(1.15);
                    }
                    100% {
                        transform: scale(1.1);
                    }
                }
                
                .spinner-border {
                    animation: spinner-border 0.75s linear infinite;
                }
                
                @keyframes spinner-border {
                    to {
                        transform: rotate(360deg);
                    }
                }
            `}</style>
        </div>
    );
};

export default Category1;